import { Root } from './Root'
import { Content } from './Content'
import { Column } from './Column'
import { Footer } from './Footer'

export { ViewHeader } from './ViewHeader'
export { ViewWrapper } from './ViewWrapper'
export { ViewContext } from './ViewProvider'
export const View = {
  Root,
  Content,
  Column,
  Footer
}
